import { getFunctions, httpsCallable } from 'firebase/functions';
import { app } from '../firebase';
import { withTimeout } from './withTimeout';

const functions = getFunctions(app, 'europe-west1');

// These run before the user is signed in and only gate abuse, so a slow or
// unreachable backend must fail open rather than block the form forever.
const RATE_LIMIT_TIMEOUT_MS = 8000;

export interface RateLimitResult {
  allowed: boolean;
  message: string | null;
  retryAfter: number | null;
  error?: boolean;
}

export const checkSignInRateLimit = async (
  email: string
): Promise<RateLimitResult> => {
  try {
    const fn = httpsCallable<{ email: string }, RateLimitResult>(
      functions,
      'rateLimitedSignIn'
    );
    const result = await withTimeout(
      fn({ email }),
      RATE_LIMIT_TIMEOUT_MS,
      'Rate limit check timed out'
    );
    return result.data;
  } catch {
    return { allowed: true, message: null, retryAfter: null };
  }
};

export const checkSignUpRateLimit = async (
  email: string
): Promise<RateLimitResult> => {
  try {
    const fn = httpsCallable<{ email: string }, RateLimitResult>(
      functions,
      'rateLimitedSignUp'
    );
    const result = await withTimeout(
      fn({ email }),
      RATE_LIMIT_TIMEOUT_MS,
      'Rate limit check timed out'
    );
    return result.data;
  } catch {
    return { allowed: true, message: null, retryAfter: null };
  }
};

export const checkPasswordResetRateLimit = async (
  email: string
): Promise<RateLimitResult> => {
  try {
    const fn = httpsCallable<{ email: string }, RateLimitResult>(
      functions,
      'rateLimitedPasswordReset'
    );
    const result = await withTimeout(
      fn({ email }),
      RATE_LIMIT_TIMEOUT_MS,
      'Rate limit check timed out'
    );
    return result.data;
  } catch {
    return { allowed: true, message: null, retryAfter: null };
  }
};

export const checkWriteRateLimit = async (): Promise<RateLimitResult> => {
  try {
    const fn = httpsCallable<void, RateLimitResult>(
      functions,
      'checkWriteRateLimit'
    );
    const result = await withTimeout(
      fn(),
      RATE_LIMIT_TIMEOUT_MS,
      'Rate limit check timed out'
    );
    return result.data;
  } catch {
    return { allowed: true, message: null, retryAfter: null };
  }
};
